import axios          from "axios"
import BaseApiService from "@/api/BaseApiService"

export default class AuthService extends BaseApiService {
  // public async getUserToken(usrId: number, oneTimeToken: string): Promise<any> {
  //   return await this.makeRequest("get", "/auth/check-token", {
  //     usrId: usrId,
  //     ott: oneTimeToken
  //   })
  // }

  getUserToken(usrId: number, oneTimeToken: string) {
    return axios.get(this.getApiUrl('/auth/check-token'), {params: {usrId: usrId, ott: oneTimeToken}})
      .then(res => {
        return res.data;
      })
      .catch(error => {
        return {success: false};
      });
  }
}
